<script>
  import { getContext } from "svelte";

  export let stops = [];

  const { cabrini_label, formatPercent } = getContext("bga-race");

  $: bins = processStops(stops);

  function processStops(stops = []) {
    const bins = [];
    for (let i = 0; i < stops.length; i += 2) {
      bins.push([stops[i], stops[i + 1]]);
    }
    return bins;
  }
</script>

<div class="legend">
  <ol>
    {#each bins as [value, color], index}
      <li style="--bin-color:{color}">
        <span>{formatPercent(value, 0)}</span>
        {#if index === bins.length - 1}<span>100%</span>{/if}
      </li>
    {/each}
  </ol>
  <span class="cabrini">{cabrini_label}</span>
</div>

<style>
  .legend {
    --gap: 0.25em;
    margin: 0 0 var(--gap) 0;
  }

  ol {
    margin: 0 0 var(--gap) 0;
    padding: 0;
    list-style: none;
    display: flex;
    gap: var(--gap);
  }

  li {
    position: relative;
    flex: 1 1;
    margin: var(--gap) 0 0 0;
  }

  li::after {
    content: "";
    display: block;
    height: 1em;
    width: 100%;
    background: var(--bin-color, transparent);
  }

  li span {
    display: block;
    font: bold 14px/1em var(--fonts-sans);
    transform: translate(-50%, 0);
    text-align: center;
    width: -moz-fit-content;
    width: fit-content;
    margin: 0 0 var(--gap) 0;
  }

  li:first-child span {
    transform: none;
  }

  li span:nth-child(2) {
    position: absolute;
    right: 0;
    top: 0;
    transform: none;
  }
  .cabrini {
    display: inline-block;
    width: 100%;
    text-align: center;
    font: 14px/1em var(--fonts-sans);
  }

  .cabrini::before {
    content: "";
    display: inline-block;
    height: 0.4em;
    width: 1em;
    background: black;
    margin: 0 0.25em 0 0;
    transform: translate(0, -0.1em);
  }
</style>
